import LabelGroup from './label-group'

import styles from './label.module.scss'

type LabelProps = {
  children: string
}

const Label = ({ children }: LabelProps): JSX.Element => <div className={styles.label}>{children}</div>

Label.Group = LabelGroup

export default Label
